import { Add, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { IPolicy, IResource, PolicyRequirement, RoleResourcePermission } from "../../../commons/interfaces";
import { Mode, RoleTableMode } from "../../../constants/enums";
import useStrings from "../../../hooks/useStrings";
import Box from "../../Box";
import Button from "../../Button";
import Typography from "../../Typography";
import { ModalAddResourceController } from "../Modal";
import { ResourcePermissionTable } from "../Table";

export const PolicyResources = ({
    data,
    mode,
    resources,
    onAddResource,
    onChangeValue,
}: {
    data: IPolicy;
    mode: Mode;
    resources: IResource[];
    onAddResource: (resourceData: IResource[]) => void;
    onChangeValue: (key: keyof IPolicy) => (value: string | number | PolicyRequirement[] | RoleResourcePermission[]) => void;
}) => {
    const Strings = useStrings();
    const [roleTableMode, setRoleTableMode] = useState<RoleTableMode>("normal");

    const [visibled, setVisibled] = useState<boolean>(false);

    const resourceData = useMemo(
        () =>
            (data?.resources || []).map(
                (el) =>
                    ({
                        resourceCode: el.resourceCode,
                    } as IResource)
            ),
        [data?.resources]
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h5">{Strings.POLICY.RESOURCES}</Typography>
                    {mode !== Mode.View && (
                        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                            <Button
                                color={"dark"}
                                variant="outlined"
                                onClick={() => setRoleTableMode((prev) => (prev === "normal" ? "advance" : "normal"))}
                            >
                                {roleTableMode === "normal" ? <ExpandMore /> : <ExpandLess />}
                                &nbsp;
                                {roleTableMode !== "normal" ? Strings.Common.NORMAL : Strings.Common.ADVANCE}
                            </Button>
                            <Button color={"dark"} onClick={() => setVisibled(true)}>
                                <Add />
                                &nbsp;
                                {Strings.Common.ADD_RESOURCES}
                            </Button>
                        </Box>
                    )}
                </Box>
            </Grid>
            <Grid item xs={12}>
                <ResourcePermissionTable
                    tableMode={roleTableMode}
                    disabled={mode === Mode.View}
                    resources={resources || []}
                    resourceModules={data?.resources || []}
                    onChangePermission={onChangeValue("resources")}
                />
            </Grid>
            {visibled && (
                <ModalAddResourceController
                    key={JSON.stringify(resourceData)}
                    resources={resources || []}
                    resourceData={resourceData}
                    visibled={visibled}
                    serviceCode={data.serviceCode}
                    onClose={() => setVisibled(false)}
                    onSubmit={onAddResource}
                />
            )}
        </Grid>
    );
};

export default PolicyResources;
